import { makeStyles } from '@material-ui/core/styles';
import { filters } from '../../contexts';

export default makeStyles(() => ({
  accessDenied: {
    height: '70%',
    '& > .MuiIcon-root': {
      height: '6rem',
      width: '6rem',
      marginBottom: '2rem',
      '& img': {
        filter: filters.primary.main,
      },
    },
  },
  subtitle: {
    marginBottom: '1rem',
    textAlign: 'center',
  },
  buttonGroup: {
    padding: '1.15rem 0',
    '& > a:first-child': {
      marginRight: '0.5rem',
    },
  },
}));
